export default {
  administrationMetadata: {
    banned: 'Banned',
    registrationDate: 'Reg. date',
    lastEnter: 'Last enter',
    companies: 'Companies',
    copyLinkSuccess: 'Has been copied',
    copyUid: 'Copy UID',
    copyMail: 'Copy Email',
    copyLinkFailed: 'Error when copy email',
    text: 'Text',
    byCompany: 'By company',
    changeUserData: 'Change user data',
    changeUserName: 'Change the username',
    changeEmail: 'Change email',
    newEmail: 'New email',
    ban: 'Ban',
    unban: 'Unban',
    setImp: 'Grant a role to log in as another user',
    unsetImp: 'Revoke a role to log in as another user',
    impersonate: 'Impersonate as this user',
    imp: 'Impers.',
    platformAdmin: 'Platform admin',
    admin: 'Administrator',
    platformAdminHint: 'User will get access to the "Administration" section in the side menu',
    adminHint: 'User will be able to view all platform pages, but not to log in as other users',
    impHint: 'User will be able to log in as other users',
    setAdmin: 'Grant administrator role',
    unsetAdmin: 'Revoke administrator role',
    setPlatformAdmin: 'Grant platform admin role',
    unsetPlatformAdmin: 'Revoke platform admin role',
    successMessages: {
      changeUserName: 'The user data successfully updated',
    },
    errorMessages: {
      changeUserName: 'The user data was entered incorrectly',
    },
  },
};
